/**
 * Provides the active client context (selected tenant) to the whole app.
 * Persists selection to localStorage. Resets to null if stored id not in list.
 */

import { useState, useEffect, type ReactNode } from 'react'
import { ActiveClientContext, getStoredClientId, storeClientId, useClientsList } from '@/hooks/useClients'

export function ActiveClientProvider({ children }: { children: ReactNode }) {
  const [activeClientId, setActiveClientIdState] = useState<string | null>(getStoredClientId)
  const { data: clients } = useClientsList()

  // Validate stored id against actual list
  useEffect(() => {
    if (clients && activeClientId && !clients.find((c) => c.id === activeClientId)) {
      setActiveClientIdState(null)
      storeClientId(null)
    }
  }, [clients, activeClientId])

  function setActiveClientId(id: string | null) {
    setActiveClientIdState(id)
    storeClientId(id)
  }

  return (
    <ActiveClientContext.Provider value={{ activeClientId, setActiveClientId }}>
      {children}
    </ActiveClientContext.Provider>
  )
}
